import { BaseModel } from './BaseModel';
import LearningUnit from './LearningUnit';
import Post from './Post';

export class BunnyVideo extends BaseModel {
  static get entity() {
    return 'bunny_videos';
  }

  static fields() {
    return {
      id: this.attr(null),
      guid: this.attr(null),
      title: this.attr(null),
      learning_unit_id: this.attr(null),
      learning_unit: this.belongsTo(LearningUnit, 'learning_unit_id'),
      post_id: this.attr(null),
      post: this.belongsTo(Post, 'post_id')
    };
  }

  static apiConfig = {
    actions: {
      getUploadToken(body) {
        return this.post(`/bunny-videos/upload`, body,{save:false});
      }
    }
  };
}

export default BunnyVideo;
